import React from 'react';
import './index.css'
import { useMediaQuery } from '../../hooks/MediaQuery.hook';

export default function SecondDescription(){
    const matches = useMediaQuery('(min-width: 768px)');

    return (
        <div className='home-details no-web-display' style={matches ? { padding: '20px' }:{}}>
            <h1 className='heading'>
                <span className='site-title'>Sports<span className='feed'>Feed</span>24</span>
                {' '}– Watch Free Live Sports Streams in HD onsportsfeed24
            </h1>
            <p className='card-description'>
               Sportsfeed24 brings every major live sporting event to your screen — completely free,
                with no sign-up and no subscription. From Premier League football and PSL cricket to NFL
                Sundays, NBA playoffs, UFC fight nights, and Formula 1 race weekends, we cover it all in
                sharp HD on any device.
            </p>
            <p className='card-description'>
                Opensportsfeed24, pick today&apos;s match, choose a player, and start watching in seconds.
                Our streams are fast, stable, and updated throughout the day so you always have a reliable
                link when kick-off arrives.
            </p>
            <div>
                <ul>
                    <li>
                        <p>
                            <span className='collection'><a href="/streams/Soccer">Live Soccer &amp; Football Streams</a></span>
                        </p>
                        <p className='card-description'>
                            Football fans turn to SportsFeed24 for daily{' '}
                            <a href='/streams/Soccer'>soccer streams</a> from the Premier League, La Liga,
                            Serie A, Bundesliga, Ligue 1, and the UEFA Champions League. Every matchday
                            brings fresh links with multiple player options — pick the stream that works best
                            on your connection and never miss a goal, penalty, or last-minute winner.
                        </p>
                    </li>
                    <li className='nav-item'>
                        <p className='nav-link'>
                            <span className='collection'>Cricket Live Streams – PSL, IPL &amp; International</span>
                        </p>
                        <p className='card-description'>
                            Cricket holds a special place for fans in Pakistan and across South Asia.
                           Sportsfeed24 streams Pakistan Super League, IPL, T20 World Cup, bilateral
                            series, ODIs, and Test matches live — follow every over, wicket, and boundary
                            without paying for a cable package.
                        </p>
                    </li>
                    <li className='nav-item'>
                        <p className='nav-link'>
                            <span className='collection'><a href='/streams/nfl'>NFL Live Streams</a></span>
                        </p>
                        <p className='card-description'>
                            American football fans can catch every NFL game on SportsFeed24 — regular season,
                            wild-card round, conference championships, and the Super Bowl included. Our{' '}
                            <a href='/streams/nfl'>NFL streams</a> are listed on the homepage each Sunday
                            and updated through the full season schedule.
                        </p>
                    </li>
                    <li className='nav-item'>
                        <p className='nav-link'>
                            <span className='collection'><a href='/streams/nba'>NBA Live Streams</a></span>
                        </p>
                        <p className='card-description'>
                            Basketball never stops onsportsfeed24. Stream NBA regular season games,
                            Christmas Day specials, and every playoff series through to the Finals.
                            Free <a href='/streams/nba'>NBA streams</a> are available on desktop, mobile,
                            and tablet with no account required.
                        </p>
                    </li>
                    <li className='nav-item'>
                        <p className='nav-link'>
                            <span className='collection'><a href='/streams/mma'>UFC &amp; MMA Streams</a></span>
                        </p>
                        <p className='card-description'>
                            Mixed martial arts fans get full coverage of UFC Fight Night cards, numbered
                            events, and major pay-per-view bouts on SportsFeed24. Watch every round of{' '}
                            <a href='/streams/mma'>UFC action</a> in HD — prelims and main card included.
                        </p>
                    </li>
                    <li className='nav-item'>
                        <p className='nav-link'>
                            <span className='collection'><a href='/streams/Boxing'>Boxing Live Streams</a></span>
                        </p>
                        <p className='card-description'>
                            From world-title fights to undercard bouts, SportsFeed24 covers major boxing
                            events across WBA, WBC, IBF, and WBO promotions. Find tonight&apos;s{' '}
                            <a href='/streams/Boxing'>boxing streams</a> on the homepage and watch
                            every punch live.
                        </p>
                    </li>
                    <li className='nav-item'>
                        <p className='nav-link'>
                            <span className='collection'><a href='/streams/F1'>Formula 1 &amp; Motorsport Streams</a></span>
                        </p>
                        <p className='card-description'>
                            Race weekends come alive onsportsfeed24. Stream every Formula 1 Grand Prix,
                            qualifying session, and sprint race, plus MotoGP events when they are on the
                            schedule. Our <a href='/streams/F1'>F1 streams</a> keep you on track from
                            lights out to the chequered flag.
                        </p>
                    </li>
                    <li className='nav-item'>
                        <p className='nav-link'>
                            <span className='collection'>More Sports – Tennis, Rugby &amp; NHL</span>
                        </p>
                        <p className='card-description'>
                            SportsFeed24 goes beyond the headline sports. Follow Grand Slam tennis,
                            Six Nations rugby, NHL ice hockey, and MLS soccer — all from one homepage.
                            Whatever sport you follow,sportsfeed24 is built to keep you watching.
                        </p>
                    </li>
                    <li className='nav-item'>
                        <p className='nav-link'>
                            <span className='collection'>Why Fans ChooseSportsfeed24</span>
                        </p>
                        <ol style={{lineHeight: 1.8}}>
                            <li className='card-description'>
                                Completely free — no subscription, no credit card, no registration form.
                            </li>
                            <li className='card-description'>
                                HD streams with multiple player options for every match.
                            </li>
                            <li className='card-description'>
                                Daily updated schedules so you always know what is live today.
                            </li>
                            <li className='card-description'>
                                Works on phone, tablet, laptop, and smart TV browsers.
                            </li>
                            <li className='card-description'>
                                One site for soccer, cricket, NFL, NBA, UFC, boxing, F1, and more.
                            </li>
                        </ol>
                    </li>

                    <li className='nav-item'>
                        <p className='card-description'>
                            <strong>Bookmarksportsfeed24 and never miss another live match — free sports streaming, every day.</strong>
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    );
};
